/**
 * Um vínculo, na tela de escolha: "entrar como profissional na marca X".
 */
import { Group, Stack, Text, ThemeIcon, UnstyledButton } from '@mantine/core';
import type { ReactNode } from 'react';

export interface ContextCardProps {
  brandName: string;
  roleLabel: string;
  detail?: string | null;
  icon: ReactNode;
  disabled?: boolean;
  hint?: string | null;
  onClick: () => void;
}

export function ContextCard({ brandName, roleLabel, detail, icon, disabled, hint, onClick }: ContextCardProps) {
  return (
    <UnstyledButton
      onClick={onClick}
      disabled={disabled}
      style={{
        display: 'block',
        width: '100%',
        padding: 'var(--eva-space-4)',
        borderRadius: 'var(--eva-radius-md)',
        background: 'var(--eva-surface)',
        border: '1px solid var(--eva-border)',
        opacity: disabled ? 0.6 : 1,
        transition: 'border-color 120ms ease, transform 120ms ease',
      }}
      className="eva-context-card"
    >
      <Group wrap="nowrap" gap="md">
        <ThemeIcon size={44} radius="xl" variant="light" color="brand">
          {icon}
        </ThemeIcon>
        <Stack gap={2} style={{ flex: 1, minWidth: 0 }}>
          <Text fw={600} truncate>{roleLabel}</Text>
          <Text fz="sm" c="dimmed" truncate>{detail ? `${brandName} · ${detail}` : brandName}</Text>
          {hint && <Text fz="xs" c="var(--eva-text-faint)">{hint}</Text>}
        </Stack>
      </Group>
    </UnstyledButton>
  );
}
